/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreClient from '@azure/core-client';

export const User: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'User',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            githubLogin: {
                constraints: {
                    Pattern: new RegExp('^([a-zA-Z\\d]+-)*[a-zA-Z\\d]+\\/$'),
                    MaxLength: 300,
                },
                serializedName: 'githubLogin',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const DeleteCommand: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'DeleteCommand',
        modelProperties: {
            oid: {
                constraints: {
                    Pattern: new RegExp(
                        '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'
                    ),
                    MaxLength: 36,
                },
                serializedName: 'oid',
                required: true,
                type: {
                    name: 'String',
                },
            },
            tid: {
                constraints: {
                    Pattern: new RegExp(
                        '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'
                    ),
                    MaxLength: 36,
                },
                serializedName: 'tid',
                required: true,
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const UserProgress: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'UserProgress',
        modelProperties: {
            userId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'userId',
                type: {
                    name: 'String',
                },
            },
            courseId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'courseId',
                type: {
                    name: 'String',
                },
            },
            units: {
                serializedName: 'units',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'UnitProgress',
                        },
                    },
                },
            },
        },
    },
};

export const UnitProgress: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'UnitProgress',
        modelProperties: {
            unitId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'unitId',
                required: true,
                type: {
                    name: 'String',
                },
            },
            lessons: {
                serializedName: 'lessons',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'LessonProgress',
                        },
                    },
                },
            },
        },
    },
};

export const LessonProgress: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'LessonProgress',
        modelProperties: {
            lessonId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'lessonId',
                required: true,
                type: {
                    name: 'String',
                },
            },
            parts: {
                serializedName: 'parts',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'LessonPartProgress',
                        },
                    },
                },
            },
        },
    },
};

export const LessonPartProgress: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'LessonPartProgress',
        modelProperties: {
            partId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'partId',
                required: true,
                type: {
                    name: 'String',
                },
            },
            percentComplete: {
                constraints: {
                    InclusiveMaximum: 100,
                    InclusiveMinimum: 0,
                },
                serializedName: 'percentComplete',
                required: true,
                type: {
                    name: 'Number',
                },
            },
            questionAnswers: {
                serializedName: 'questionAnswers',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'QuestionAnswer',
                        },
                    },
                },
            },
        },
    },
};

export const QuestionAnswer: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'QuestionAnswer',
        modelProperties: {
            questionId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'questionId',
                required: true,
                type: {
                    name: 'String',
                },
            },
            timestamp: {
                serializedName: 'timestamp',
                required: true,
                type: {
                    name: 'DateTime',
                },
            },
            response: {
                serializedName: 'response',
                required: true,
                type: {
                    name: 'any',
                },
            },
        },
    },
};

export const Project: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Project',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                type: {
                    name: 'String',
                },
            },
            projectId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'projectId',
                type: {
                    name: 'String',
                },
            },
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: [
                        'abap',
                        'bat',
                        'bibtex',
                        'clojure',
                        'coffeescript',
                        'c',
                        'cpp',
                        'csharp',
                        'dockercompose',
                        'css',
                        'cuda-cpp',
                        'diff',
                        'dockerfile',
                        'fsharp',
                        'git-commit',
                        'git-rebase',
                        'go',
                        'groovy',
                        'handlebars',
                        'haml',
                        'html',
                        'ini',
                        'java',
                        'javascript',
                        'javascriptreact',
                        'json',
                        'jsonc',
                        'latex',
                        'less',
                        'lua',
                        'makefile',
                        'markdown',
                        'objective-c',
                        'objective-cpp',
                        'perl',
                        'perl6',
                        'php',
                        'plaintext',
                        'powershell',
                        'jade',
                        'pug',
                        'python',
                        'r',
                        'razor',
                        'ruby',
                        'rust',
                        'scss',
                        'sass',
                        'shaderlab',
                        'shellscript',
                        'slim',
                        'sql',
                        'stylus',
                        'swift',
                        'typescript',
                        'typescriptreact',
                        'tex',
                        'vb',
                        'vue',
                        'vue-html',
                        'xml',
                        'xsl',
                        'yaml',
                    ],
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            publicUrl: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'publicUrl',
                type: {
                    name: 'String',
                },
            },
            publicUrlDisabled: {
                serializedName: 'publicUrlDisabled',
                type: {
                    name: 'Boolean',
                },
            },
            publishOnUpdate: {
                serializedName: 'publishOnUpdate',
                type: {
                    name: 'Boolean',
                },
            },
            lastPublished: {
                serializedName: 'lastPublished',
                type: {
                    name: 'DateTime',
                },
            },
            lastUpdated: {
                serializedName: 'lastUpdated',
                type: {
                    name: 'DateTime',
                },
            },
            lastUpdatePublished: {
                serializedName: 'lastUpdatePublished',
                type: {
                    name: 'Boolean',
                },
            },
            sharedLinkId: {
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z0-9]{20}$'),
                    MaxLength: 20,
                    MinLength: 20,
                },
                serializedName: 'sharedLinkId',
                type: {
                    name: 'String',
                },
            },
            tags: {
                constraints: {
                    MaxItems: 30,
                    UniqueItems: true,
                },
                serializedName: 'tags',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp('^(?:\\S|\\S.{0,49}\\S)$'),
                            MaxLength: 50,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};

export const CvsValidationResponse: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'CvsValidationResponse',
        modelProperties: {
            data: {
                serializedName: 'data',
                required: true,
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Dictionary',
                            value: { type: { name: 'any' } },
                        },
                    },
                },
            },
            included: {
                serializedName: 'included',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Dictionary',
                            value: { type: { name: 'any' } },
                        },
                    },
                },
            },
        },
    },
};

export const ImmersiveReaderConfig: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'ImmersiveReaderConfig',
        modelProperties: {
            endpoint: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'endpoint',
                required: true,
                type: {
                    name: 'String',
                },
            },
            token: {
                constraints: {
                    Pattern: new RegExp('^(?:[\\w-]{0,1000}\\.){2}[\\w-]{0,1000}$'),
                    MaxLength: 3500,
                },
                serializedName: 'token',
                required: true,
                type: {
                    name: 'String',
                },
            },
            expiresOn: {
                serializedName: 'expiresOn',
                required: true,
                type: {
                    name: 'DateTime',
                },
            },
        },
    },
};

export const Operation: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Operation',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operationId',
                required: true,
                type: {
                    name: 'String',
                },
            },
            status: {
                serializedName: 'status',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['not-started', 'running', 'succeeded', 'failed'],
                },
            },
            created: {
                serializedName: 'created',
                required: true,
                type: {
                    name: 'DateTime',
                },
            },
            lastUpdated: {
                serializedName: 'lastUpdated',
                required: true,
                type: {
                    name: 'DateTime',
                },
            },
            error: {
                serializedName: 'error',
                type: {
                    name: 'Composite',
                    className: 'ErrorDetail',
                },
            },
        },
    },
};

export const ErrorDetail: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'ErrorDetail',
        modelProperties: {
            code: {
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z\\d]{1,100}$'),
                    MaxLength: 100,
                },
                serializedName: 'code',
                required: true,
                type: {
                    name: 'String',
                },
            },
            message: {
                constraints: {
                    MaxLength: 1000,
                },
                serializedName: 'message',
                required: true,
                type: {
                    name: 'String',
                },
            },
            details: {
                serializedName: 'details',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'ErrorDetail',
                        },
                    },
                },
            },
        },
    },
};

export const Curriculum: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Curriculum',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                readOnly: true,
                type: {
                    name: 'String',
                },
            },
            curriculumId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'curriculumId',
                required: true,
                readOnly: true,
                type: {
                    name: 'String',
                },
            },
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['course', 'coding-activity'],
                },
            },
            platform: {
                serializedName: 'platform',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['python', 'html'],
                },
            },
            state: {
                serializedName: 'state',
                required: true,
                readOnly: true,
                type: {
                    name: 'Enum',
                    allowedValues: [
                        'creating',
                        'draft',
                        'updating',
                        'publishing',
                        'published',
                        'unpublishing',
                        'deleting',
                    ],
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            tags: {
                constraints: {
                    MaxItems: 30,
                    UniqueItems: true,
                },
                serializedName: 'tags',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp('^(?:\\S|\\S.{0,49}\\S)$'),
                            MaxLength: 50,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            repoName: {
                constraints: {
                    Pattern: new RegExp('^(([a-zA-Z\\d]+-)*[a-zA-Z\\d]+\\/)?([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)$'),
                    MaxLength: 300,
                },
                serializedName: 'repoName',
                readOnly: true,
                type: {
                    name: 'String',
                },
            },
            created: {
                serializedName: 'created',
                required: true,
                readOnly: true,
                type: {
                    name: 'DateTime',
                },
            },
            lastUpdated: {
                serializedName: 'lastUpdated',
                required: true,
                readOnly: true,
                type: {
                    name: 'DateTime',
                },
            },
            lastPublished: {
                serializedName: 'lastPublished',
                readOnly: true,
                type: {
                    name: 'DateTime',
                },
            },
            courseId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'courseId',
                readOnly: true,
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const StandardGroup: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'StandardGroup',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            displayName: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,98}\\S)$'),
                    MaxLength: 100,
                },
                serializedName: 'displayName',
                required: true,
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            author: {
                serializedName: 'author',
                type: {
                    name: 'Composite',
                    className: 'Contact',
                },
            },
            license: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'license',
                type: {
                    name: 'String',
                },
            },
            standards: {
                serializedName: 'standards',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Standard',
                        },
                    },
                },
            },
        },
    },
};

export const Contact: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Contact',
        modelProperties: {
            displayName: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'displayName',
                required: true,
                type: {
                    name: 'String',
                },
            },
            email: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:[a-z0-9!#$%&\'*+\\/=?^_`{|}~-]{1,50}(?:\\.[a-z0-9!#$%&\'*+\\/=?^_`{|}~-]{1,50}){0,50}|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f]){0,50}")@(?:(?:[a-z0-9](?:[a-z0-9-]{0,50}[a-z0-9])?\\.){1,50}[a-z0-9](?:[a-z0-9-]{0,50}[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]{0,50}[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f]){1,50})\\])$'
                    ),
                    MaxLength: 250,
                },
                serializedName: 'email',
                type: {
                    name: 'String',
                },
            },
            photo: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'photo',
                type: {
                    name: 'String',
                },
            },
            affiliation: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'affiliation',
                type: {
                    name: 'String',
                },
            },
            homePage: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'homePage',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const Standard: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Standard',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            displayName: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,98}\\S)$'),
                    MaxLength: 100,
                },
                serializedName: 'displayName',
                required: true,
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            audience: {
                constraints: {
                    MaxLength: 100,
                },
                serializedName: 'audience',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const LearningPath: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'LearningPath',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            locale: {
                defaultValue: 'en-US',
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z]{2,4}(?:-[a-zA-Z]{4})?(?:-([a-zA-Z]{2}|\\d{3}))?$'),
                    MaxLength: 12,
                    MinLength: 2,
                },
                serializedName: 'locale',
                required: true,
                type: {
                    name: 'String',
                },
            },
            icon: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'icon',
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            objectives: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'objectives',
                type: {
                    name: 'String',
                },
            },
            brand: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'brand',
                required: true,
                type: {
                    name: 'String',
                },
            },
            level: {
                serializedName: 'level',
                type: {
                    name: 'Enum',
                    allowedValues: ['beginner', 'intermediate', 'advanced', 'expert'],
                },
            },
            prerequisites: {
                serializedName: 'prerequisites',
                type: {
                    name: 'Composite',
                    className: 'Prerequisites',
                },
            },
            courses: {
                serializedName: 'courses',
                required: true,
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                            MaxLength: 50,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};

export const Prerequisites: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Prerequisites',
        modelProperties: {
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            recommended: {
                serializedName: 'recommended',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp(
                                '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                            ),
                            MaxLength: 500,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            hiddenBefore: {
                serializedName: 'hiddenBefore',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp(
                                '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                            ),
                            MaxLength: 500,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            lockedBefore: {
                serializedName: 'lockedBefore',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp(
                                '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                            ),
                            MaxLength: 500,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};

export const Course: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Course',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['course', 'coding-activity'],
                },
            },
            platform: {
                serializedName: 'platform',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['python', 'html'],
                },
            },
            locale: {
                defaultValue: 'en-US',
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z]{2,4}(?:-[a-zA-Z]{4})?(?:-([a-zA-Z]{2}|\\d{3}))?$'),
                    MaxLength: 12,
                    MinLength: 2,
                },
                serializedName: 'locale',
                required: true,
                type: {
                    name: 'String',
                },
            },
            cardImage: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'cardImage',
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            objectives: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'objectives',
                type: {
                    name: 'String',
                },
            },
            authors: {
                serializedName: 'authors',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Contact',
                        },
                    },
                },
            },
            level: {
                serializedName: 'level',
                type: {
                    name: 'Enum',
                    allowedValues: ['beginner', 'intermediate', 'advanced', 'expert'],
                },
            },
            prerequisites: {
                serializedName: 'prerequisites',
                type: {
                    name: 'Composite',
                    className: 'Prerequisites',
                },
            },
            duration: {
                constraints: {
                    InclusiveMaximum: 500000,
                    InclusiveMinimum: 0,
                },
                serializedName: 'duration',
                type: {
                    name: 'Number',
                },
            },
            profileName: {
                constraints: {
                    Pattern: new RegExp('^[-\\w]{1,100}$'),
                    MaxLength: 100,
                },
                serializedName: 'profileName',
                type: {
                    name: 'String',
                },
            },
            pythonVersion: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'pythonVersion',
                type: {
                    name: 'String',
                },
            },
            units: {
                serializedName: 'units',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Unit',
                        },
                    },
                },
            },
            glossary: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'glossary',
                type: {
                    name: 'String',
                },
            },
            educatorResources: {
                serializedName: 'educatorResources',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'EducatorResource',
                        },
                    },
                },
            },
            tags: {
                constraints: {
                    MaxItems: 30,
                    UniqueItems: true,
                },
                serializedName: 'tags',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp('^(?:\\S|\\S.{0,49}\\S)$'),
                            MaxLength: 50,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};

export const Unit: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Unit',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            locale: {
                defaultValue: 'en-US',
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z]{2,4}(?:-[a-zA-Z]{4})?(?:-([a-zA-Z]{2}|\\d{3}))?$'),
                    MaxLength: 12,
                    MinLength: 2,
                },
                serializedName: 'locale',
                required: true,
                type: {
                    name: 'String',
                },
            },
            icon: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'icon',
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            objectives: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'objectives',
                type: {
                    name: 'String',
                },
            },
            author: {
                serializedName: 'author',
                type: {
                    name: 'Composite',
                    className: 'Contact',
                },
            },
            level: {
                serializedName: 'level',
                type: {
                    name: 'Enum',
                    allowedValues: ['beginner', 'intermediate', 'advanced', 'expert'],
                },
            },
            prerequisites: {
                serializedName: 'prerequisites',
                type: {
                    name: 'Composite',
                    className: 'Prerequisites',
                },
            },
            duration: {
                constraints: {
                    InclusiveMaximum: 500000,
                    InclusiveMinimum: 0,
                },
                serializedName: 'duration',
                type: {
                    name: 'Number',
                },
            },
            order: {
                constraints: {
                    InclusiveMaximum: 1000,
                    InclusiveMinimum: 0,
                },
                serializedName: 'order',
                required: true,
                type: {
                    name: 'Number',
                },
            },
            lessons: {
                serializedName: 'lessons',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Lesson',
                        },
                    },
                },
            },
        },
    },
};

export const Lesson: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Lesson',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            locale: {
                defaultValue: 'en-US',
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z]{2,4}(?:-[a-zA-Z]{4})?(?:-([a-zA-Z]{2}|\\d{3}))?$'),
                    MaxLength: 12,
                    MinLength: 2,
                },
                serializedName: 'locale',
                required: true,
                type: {
                    name: 'String',
                },
            },
            icon: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'icon',
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                type: {
                    name: 'String',
                },
            },
            objectives: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'objectives',
                type: {
                    name: 'String',
                },
            },
            author: {
                serializedName: 'author',
                type: {
                    name: 'Composite',
                    className: 'Contact',
                },
            },
            level: {
                serializedName: 'level',
                type: {
                    name: 'Enum',
                    allowedValues: ['beginner', 'intermediate', 'advanced', 'expert'],
                },
            },
            prerequisites: {
                serializedName: 'prerequisites',
                type: {
                    name: 'Composite',
                    className: 'Prerequisites',
                },
            },
            standards: {
                serializedName: 'standards',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp(
                                '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                            ),
                            MaxLength: 500,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            duration: {
                constraints: {
                    InclusiveMaximum: 500000,
                    InclusiveMinimum: 0,
                },
                serializedName: 'duration',
                type: {
                    name: 'Number',
                },
            },
            order: {
                constraints: {
                    InclusiveMaximum: 1000,
                    InclusiveMinimum: 0,
                },
                serializedName: 'order',
                required: true,
                type: {
                    name: 'Number',
                },
            },
            editors: {
                serializedName: 'editors',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'EditorSettings',
                        },
                    },
                },
            },
            terminal: {
                serializedName: 'terminal',
                type: {
                    name: 'Composite',
                    className: 'TerminalSettings',
                },
            },
            layout: {
                serializedName: 'layout',
                type: {
                    name: 'Composite',
                    className: 'LayoutSettings',
                },
            },
            parts: {
                serializedName: 'parts',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'LessonPart',
                        },
                    },
                },
            },
            educatorResources: {
                serializedName: 'educatorResources',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'EducatorResource',
                        },
                    },
                },
            },
        },
    },
};

export const EditorSettings: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'EditorSettings',
        modelProperties: {
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: [
                        'abap',
                        'bat',
                        'bibtex',
                        'clojure',
                        'coffeescript',
                        'c',
                        'cpp',
                        'csharp',
                        'dockercompose',
                        'css',
                        'cuda-cpp',
                        'diff',
                        'dockerfile',
                        'fsharp',
                        'git-commit',
                        'git-rebase',
                        'go',
                        'groovy',
                        'handlebars',
                        'haml',
                        'html',
                        'ini',
                        'java',
                        'javascript',
                        'javascriptreact',
                        'json',
                        'jsonc',
                        'latex',
                        'less',
                        'lua',
                        'makefile',
                        'markdown',
                        'objective-c',
                        'objective-cpp',
                        'perl',
                        'perl6',
                        'php',
                        'plaintext',
                        'powershell',
                        'jade',
                        'pug',
                        'python',
                        'r',
                        'razor',
                        'ruby',
                        'rust',
                        'scss',
                        'sass',
                        'shaderlab',
                        'shellscript',
                        'slim',
                        'sql',
                        'stylus',
                        'swift',
                        'typescript',
                        'typescriptreact',
                        'tex',
                        'vb',
                        'vue',
                        'vue-html',
                        'xml',
                        'xsl',
                        'yaml',
                    ],
                },
            },
            template: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'template',
                type: {
                    name: 'String',
                },
            },
            filename: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'filename',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const TerminalSettings: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'TerminalSettings',
        modelProperties: {
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['none', 'python'],
                },
            },
            clear: {
                defaultValue: false,
                serializedName: 'clear',
                type: {
                    name: 'Boolean',
                },
            },
        },
    },
};

export const LayoutSettings: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'LayoutSettings',
        modelProperties: {
            components: {
                constraints: {
                    MaxLength: 100,
                },
                serializedName: 'components',
                type: {
                    name: 'String',
                },
            },
            explorer: {
                defaultValue: false,
                serializedName: 'explorer',
                type: {
                    name: 'Boolean',
                },
            },
        },
    },
};

export const LessonPart: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'LessonPart',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            locale: {
                defaultValue: 'en-US',
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z]{2,4}(?:-[a-zA-Z]{4})?(?:-([a-zA-Z]{2}|\\d{3}))?$'),
                    MaxLength: 12,
                    MinLength: 2,
                },
                serializedName: 'locale',
                required: true,
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            level: {
                serializedName: 'level',
                type: {
                    name: 'Enum',
                    allowedValues: ['beginner', 'intermediate', 'advanced', 'expert'],
                },
            },
            prerequisites: {
                serializedName: 'prerequisites',
                type: {
                    name: 'Composite',
                    className: 'Prerequisites',
                },
            },
            order: {
                constraints: {
                    InclusiveMaximum: 1000,
                    InclusiveMinimum: 0,
                },
                serializedName: 'order',
                required: true,
                type: {
                    name: 'Number',
                },
            },
            editors: {
                serializedName: 'editors',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'EditorSettings',
                        },
                    },
                },
            },
            terminal: {
                serializedName: 'terminal',
                type: {
                    name: 'Composite',
                    className: 'TerminalSettings',
                },
            },
            layout: {
                serializedName: 'layout',
                type: {
                    name: 'Composite',
                    className: 'LayoutSettings',
                },
            },
            contentUri: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'contentUri',
                type: {
                    name: 'String',
                },
            },
            quiz: {
                serializedName: 'quiz',
                type: {
                    name: 'Composite',
                    className: 'Quiz',
                },
            },
        },
    },
};

export const Quiz: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Quiz',
        modelProperties: {
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            validation: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'validation',
                type: {
                    name: 'String',
                },
            },
            questions: {
                serializedName: 'questions',
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'Question',
                        },
                    },
                },
            },
        },
    },
};

export const Question: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Question',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            content: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'content',
                required: true,
                type: {
                    name: 'String',
                },
            },
            hint: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'hint',
                type: {
                    name: 'String',
                },
            },
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: ['string', 'choice', 'multiple', 'mapping', 'reflection'],
                },
            },
            scrambleOrder: {
                defaultValue: true,
                serializedName: 'scrambleOrder',
                type: {
                    name: 'Boolean',
                },
            },
            scrambleChoices: {
                defaultValue: false,
                serializedName: 'scrambleChoices',
                type: {
                    name: 'Boolean',
                },
            },
            choices: {
                serializedName: 'choices',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                            MaxLength: 250,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
            responses: {
                serializedName: 'responses',
                required: true,
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'QuestionResponse',
                        },
                    },
                },
            },
        },
    },
};

export const QuestionResponse: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'QuestionResponse',
        modelProperties: {
            content: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'content',
                type: {
                    name: 'String',
                },
            },
            explanation: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'explanation',
                type: {
                    name: 'String',
                },
            },
            incorrectExplanation: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'incorrectExplanation',
                type: {
                    name: 'String',
                },
            },
            correct: {
                serializedName: 'correct',
                type: {
                    name: 'any',
                },
            },
        },
    },
};

export const EducatorResource: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'EducatorResource',
        modelProperties: {
            type: {
                constraints: {
                    Pattern: new RegExp('^[-\\w.]+\\/[-\\w.]+$'),
                    MaxLength: 100,
                },
                serializedName: 'type',
                required: true,
                type: {
                    name: 'String',
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            url: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'url',
                required: true,
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const UserContentReport: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'UserContentReport',
        modelProperties: {
            url: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'url',
                required: true,
                type: {
                    name: 'String',
                },
            },
            abuseCategory: {
                serializedName: 'abuseCategory',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: [
                        'AdultNudity',
                        'AlcoholTobaccoDrugs',
                        'ChildEndangermentExploitation',
                        'ContentInfringement',
                        'CoordinationOfHarm',
                        'Fraud',
                        'GraphicViolenceHumanGore',
                        'HateSpeech',
                        'ImminentHarmToPersonsOrProperty',
                        'NonConsensualAdultImages',
                        'OffensiveContent',
                        'ProfanityVulgarity',
                        'SexualSolicitation',
                        'Spam',
                        'SuicideSelfHarm',
                        'Terrorism',
                        'ThreatsCyberbullyingHarassment',
                        'ThreatsOrPraiseOfViolence',
                        'Trafficking',
                        'VirusSpywareMalware',
                        'Other',
                    ],
                },
            },
            reason: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'reason',
                type: {
                    name: 'String',
                },
            },
            reporterName: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'reporterName',
                type: {
                    name: 'String',
                },
            },
            reporterEmail: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:[a-z0-9!#$%&\'*+\\/=?^_`{|}~-]{1,50}(?:\\.[a-z0-9!#$%&\'*+\\/=?^_`{|}~-]{1,50}){0,50}|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f]){0,50}")@(?:(?:[a-z0-9](?:[a-z0-9-]{0,50}[a-z0-9])?\\.){1,50}[a-z0-9](?:[a-z0-9-]{0,50}[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]{0,50}[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f]){1,50})\\])$'
                    ),
                    MaxLength: 250,
                },
                serializedName: 'reporterEmail',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const ProjectTemplate: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'ProjectTemplate',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            type: {
                serializedName: 'type',
                required: true,
                type: {
                    name: 'Enum',
                    allowedValues: [
                        'abap',
                        'bat',
                        'bibtex',
                        'clojure',
                        'coffeescript',
                        'c',
                        'cpp',
                        'csharp',
                        'dockercompose',
                        'css',
                        'cuda-cpp',
                        'diff',
                        'dockerfile',
                        'fsharp',
                        'git-commit',
                        'git-rebase',
                        'go',
                        'groovy',
                        'handlebars',
                        'haml',
                        'html',
                        'ini',
                        'java',
                        'javascript',
                        'javascriptreact',
                        'json',
                        'jsonc',
                        'latex',
                        'less',
                        'lua',
                        'makefile',
                        'markdown',
                        'objective-c',
                        'objective-cpp',
                        'perl',
                        'perl6',
                        'php',
                        'plaintext',
                        'powershell',
                        'jade',
                        'pug',
                        'python',
                        'r',
                        'razor',
                        'ruby',
                        'rust',
                        'scss',
                        'sass',
                        'shaderlab',
                        'shellscript',
                        'slim',
                        'sql',
                        'stylus',
                        'swift',
                        'typescript',
                        'typescriptreact',
                        'tex',
                        'vb',
                        'vue',
                        'vue-html',
                        'xml',
                        'xsl',
                        'yaml',
                    ],
                },
            },
            title: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,498}\\S)$'),
                    MaxLength: 250,
                },
                serializedName: 'title',
                required: true,
                type: {
                    name: 'String',
                },
            },
            description: {
                constraints: {
                    Pattern: new RegExp('^(?:\\S|\\S.{0,3998}\\S)$'),
                    MaxLength: 4000,
                },
                serializedName: 'description',
                required: true,
                type: {
                    name: 'String',
                },
            },
            icon: {
                constraints: {
                    Pattern: new RegExp(
                        '^(?:(\\$\\/[\\w\\.-]{1,50}(?:\\/[\\w\\.-]{1,50}){0,19})|(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
                    ),
                    MaxLength: 1000,
                },
                serializedName: 'icon',
                required: true,
                type: {
                    name: 'String',
                },
            },
            featured: {
                defaultValue: false,
                serializedName: 'featured',
                type: {
                    name: 'Boolean',
                },
            },
            tags: {
                constraints: {
                    MaxItems: 30,
                    UniqueItems: true,
                },
                serializedName: 'tags',
                type: {
                    name: 'Sequence',
                    element: {
                        constraints: {
                            Pattern: new RegExp('^(?:\\S|\\S.{0,49}\\S)$'),
                            MaxLength: 50,
                        },
                        type: {
                            name: 'String',
                        },
                    },
                },
            },
        },
    },
};

export const SharedLink: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'SharedLink',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-zA-Z0-9]{20}$'),
                    MaxLength: 20,
                    MinLength: 20,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            type: {
                defaultValue: 'project',
                isConstant: true,
                serializedName: 'type',
                type: {
                    name: 'String',
                },
            },
            targetId: {
                constraints: {
                    Pattern: new RegExp(
                        '^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?(?::[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?){0,9}$'
                    ),
                    MaxLength: 500,
                },
                serializedName: 'targetId',
                required: true,
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const Glossary: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'Glossary',
        modelProperties: {
            id: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'id',
                required: true,
                type: {
                    name: 'String',
                },
            },
            terms: {
                serializedName: 'terms',
                required: true,
                type: {
                    name: 'Sequence',
                    element: {
                        type: {
                            name: 'Composite',
                            className: 'GlossaryTerm',
                        },
                    },
                },
            },
        },
    },
};

export const GlossaryTerm: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'GlossaryTerm',
        modelProperties: {
            term: {
                constraints: {
                    MaxLength: 100,
                },
                serializedName: 'term',
                required: true,
                type: {
                    name: 'String',
                },
            },
            definition: {
                constraints: {
                    MaxLength: 4000,
                },
                serializedName: 'definition',
                required: true,
                type: {
                    name: 'String',
                },
            },
            ignoreCase: {
                defaultValue: true,
                serializedName: 'ignoreCase',
                type: {
                    name: 'Boolean',
                },
            },
        },
    },
};

export const VsCodeEduClientDeleteUserHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientDeleteUserHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientDeleteUserProjectHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientDeleteUserProjectHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientPublishUserProjectHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientPublishUserProjectHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientUnpublishUserProjectHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientUnpublishUserProjectHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientCreateOrUpdateUserCurriculumHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientCreateOrUpdateUserCurriculumHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientDeleteUserCurriculumHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientDeleteUserCurriculumHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientPublishUserCurriculumHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientPublishUserCurriculumHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientUnpublishUserCurriculumHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientUnpublishUserCurriculumHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};

export const VsCodeEduClientDeleteCourseHeaders: coreClient.CompositeMapper = {
    type: {
        name: 'Composite',
        className: 'VsCodeEduClientDeleteCourseHeaders',
        modelProperties: {
            operationLocation: {
                serializedName: 'operation-location',
                type: {
                    name: 'String',
                },
            },
            operationId: {
                constraints: {
                    Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
                    MaxLength: 50,
                },
                serializedName: 'operation-id',
                type: {
                    name: 'String',
                },
            },
        },
    },
};
